import { BrowserCacheLocation } from '@azure/msal-browser';

type SidexApiUrls = {
    user: string;
    scd: string;
    order: string;
    employee: string;
};

type SidexEntraConfig = {
    clientId: string;
    tenantId: string;
    backendScope?: string;
};

type SidexEnvironmentOptions = {
    production: boolean;
    apiUrls: SidexApiUrls;
    entra: SidexEntraConfig;
};

const defaultLoginScopes = ['openid', 'profile', 'email', 'offline_access'];

const uniqueScopes = (scopes: string[]): string[] => [...new Set(scopes.filter((scope) => scope.length > 0))];

export const createSidexEnvironment = ({ production, apiUrls, entra }: SidexEnvironmentOptions) => ({
    production,
    apiUrls,
    msalConfig: {
        auth: {
            clientId: entra.clientId,
            authority: `https://login.microsoftonline.com/${entra.tenantId}`,
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            allowPlatformBroker: false
        }
    },
    loginRequest: {
        scopes: uniqueScopes(defaultLoginScopes)
    },
    apiTokenScopes: uniqueScopes(entra.backendScope ? [entra.backendScope] : [])
});
